<template lang="pug">
    .logo
        .main
            router-link(:to="{name: 'index'}")
                img(v-if="imgClass === 'cn'" src="~public/images/gzzoc/logo-cn.png", width="267")
                img(v-if="imgClass === 'en'" src="~public/images/gzzoc/logo-en.png", width="267")
                //- 特殊场合下有新logo并排显示
            a.ckd-logo(v-if="entrance")
                img(v-if="imgClass === 'cn'" src="~public/images/gzzoc/logo2-cn.png", width="303")
                img(v-if="imgClass === 'en'" src="~public/images/gzzoc/logo2-en.png", width="303")
</template>

<script>
import ls from '@/utils/local-storage';

export default {
    computed: {
        imgClass () {
            let cls = ls.get('lang');
            return cls === 'zh-CN' ? 'cn' : cls
        },
        type () {
            return this.$route.params.type;
        },
        entrance() {
            return (this.$route.query.entrance || this.type==='ckd_all' || this.type==='ckd_screening' || window.location.origin === 'https://zockids.gzzoc.com') ? 'CKD' : ''
        }
    }
}
</script>

<style lang="sass" scoped>
    .logo
        position: absolute
        top: 22px
        left: 22px
        z-index: 20
        cursor: pointer
    .main
        display: flex
        gap: 30px

</style>
